module.exports = __webpack_public_path__ + "img/Вывих надколенника.a8f10aaf.jpg";